import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Forgot Password flow events for the authentication system.
 *
 * These events drive the reactive password recovery process from email submission
 * to reset link generation.
 *
 * @example
 * const dispatch = injectDispatch(forgotPasswordEvents);
 * dispatch.forgotPasswordRequested('user@example.com');
 */
export const forgotPasswordEvents = eventGroup({
  source: 'auth.forgotPassword',
  events: {
    forgotPasswordRequested: type<string>(),
    forgotPasswordSucceeded: type<void>(),
    forgotPasswordFailed: type<{
      error: string;
    }>(),
  },
});
